<template>
  <div>
    <div v-for="(groupSubsidy, gIndex) in subsidy" :key="gIndex"
      v-show="gIndex === 0 || subsidyShow == true"
      class="menu-subsidy-detail"
    >
      <!-- グループ補助金表示： グループ補助金の上部にグループ補助金情報を表示-->
      <template v-if="groupSubsidy.availableData.groupInfo != null && groupSubsidy.displayGroupInfoFlg">
        <div v-show="subsidyShow || groupSubsidy.dispFlag" class="coupon-card">
          <!-- グループ補助金名称 -->
          <div class="flex-cols-2 sm:flex-col items-end sm:items-start mb-2 sm:text-center">
            <strong class="py-0.5">{{ groupSubsidy.availableData.groupInfo.groupName }}</strong>
          </div>
          <!-- グループ補助金：申込期間 -->
          <dl class="flex w-full flex-wrap gap-y-2 md:gap-y-2">
            <dt class="w-3/12 md:w-4/12 md:text-xs">
              <span class="titleblock">申込期間</span>
            </dt>
            <dd class="w-9/12 md:w-full md:text-xs">
              {{ $moment(groupSubsidy.availableData.groupInfo.receptionDateFrom).format('YYYY/MM/DD') }}
              ～
              {{ $moment(groupSubsidy.availableData.groupInfo.receptionDateTo).format('YYYY/MM/DD')  }}
            </dd>
            <!-- グループ補助金：保有枚数 -->
            <!-- 利用制限単位（usedLimUnit）が[02：契約ID毎][03：契約ID合計毎]の場合、非表示とする -->
            <template
              v-if="groupSubsidy.availableData.usedLimUnit != '02' && groupSubsidy.availableData.usedLimUnit != '03' 
                  && groupSubsidy.scrennDisplayItemList.groupRemainingCountLabel.value >= 0 && groupSubsidy.scrennDisplayItemList.groupRemainingCountLabel.value !== null"
            >
              <dt class="w-3/12 md:w-5/12 sm:w-4/12 md:text-xs">
                <span class="titleblock">保有枚数</span>
              </dt>
              <!-- 上限枚数と残枚数が設定されている場合：「X/Y枚」 -->
              <dd v-if="groupSubsidy.availableData.groupInfo.parsonalUsedMaxCnt !== null" class="w-9/12 md:w-7/12 sm:w-8/12 md:text-xs">
                {{ groupSubsidy.scrennDisplayItemList.groupRemainingCountLabel.value | formatInteger }}
                /{{groupSubsidy.availableData.groupInfo.parsonalUsedMaxCnt | formatInteger}}
                枚
              </dd>
              <!-- 上限枚数未設定かつ残枚数が設定されている場合：「X枚」 -->
              <dd v-if="groupSubsidy.availableData.groupInfo.parsonalUsedMaxCnt == null" class="w-9/12 md:w-7/12 sm:w-8/12 md:text-xs">
                {{ groupSubsidy.scrennDisplayItemList.groupRemainingCountLabel.value | formatInteger }}
                枚
              </dd>
            </template>
            <!-- グループ補助金：利用可能残金額 -->
            <template
               v-if="groupSubsidy.scrennDisplayItemList.groupRemainingAmountLabel.value >= 0 && groupSubsidy.scrennDisplayItemList.groupRemainingAmountLabel.value !== null"
            >
              <dt class="w-5/12 md:w-7/12 sm:w-5/12 md:text-xs">
                <span class="titleblock">利用可能残金額</span>
              </dt>
              <!-- 上限金額と残金が設定されている場合：「X/Y円」 -->
              <dd v-if="groupSubsidy.availableData.groupInfo.parsonalUsedMaxTotalAmt !== null" class="w-7/12 md:w-5/12 sm:w-7/12 md:text-xs">
                {{ groupSubsidy.scrennDisplayItemList.groupRemainingAmountLabel.value | formatInteger }}
                /{{groupSubsidy.availableData.groupInfo.parsonalUsedMaxTotalAmt | formatInteger}}
                円
              </dd>
              <!-- 上限金額が未設定かつ残金が設定されている場合：「X円」 -->
              <dd v-if="groupSubsidy.availableData.groupInfo.parsonalUsedMaxTotalAmt == null" class="w-7/12 md:w-5/12 sm:w-7/12 md:text-xs">
                {{ groupSubsidy.scrennDisplayItemList.groupRemainingAmountLabel.value | formatInteger }}
                円
              </dd>
            </template>
          </dl>
          <!-- グループ補助金用の内容説明 -->
          <div class="mt-4 md:text-xs">
            <div v-if="infoGroupTexts(groupSubsidy)" v-html="infoGroupTexts(groupSubsidy)" />
            <!-- グループ補助金用のWeb注記コメント -->
            <div>{{ groupSubsidy.availableData.groupInfo.dispNoteComment }}</div>
          </div>

          <!-- グループに紐づく補助金表示 -->
          <!-- 再度ループして、上階層ループのグループIDと同一のものを表示する -->
          <div v-for="(subsidy, index) in subsidy" :key="index">
            <div
              v-if="subsidy.availableData.groupInfo.groupId == groupSubsidy.availableData.groupInfo.groupId"
              v-show="subsidyShow ||  subsidy.dispFlag"
            >
              <details class="accordion-wrapper ">
                <summary class="name-coupon font-size-medium accordion-summary ">
                  <span class="accordion-item flex-cols-2 sm:flex-col items-end sm:items-start mb-2 sm:text-center">
                    <strong class="py-0.5">{{ get(subsidy, 'availableData.dispSubsidyNm') }}</strong>
                  </span>
                </summary>
              
                <!--
                  レイアウト仕様変更により一度コメントアウトする
                  UI/UX関連の場合、要確認
                -->
                <!-- <div class="mb-2">
                  <div v-if="infoTexts(subsidy)" v-html="infoTexts(subsidy)" />

                  <template v-if="!isCorporate">
                    <div v-if="applicableDegreeCntText(subsidy)" v-html="applicableDegreeCntText(subsidy)" />
                  </template>
                </div> -->
                <dl class="flex w-full flex-wrap gap-y-2 md:gap-y-2">
                  <dt class="w-3/12 md:w-4/12 md:text-xs">
                    <span class="titleblock">申込期間</span>
                  </dt>
                  <dd class="w-9/12 md:w-full md:text-xs">
                    {{ get(subsidy, 'availableData.receptionDateFrom') }}
                    ～
                    {{ get(subsidy, 'availableData.receptionDateTo') }}
                  </dd>

                  <template v-if="isCorporate(subsidy)">
                    <template
                      v-if="
                        (subsidy.availableData.parsonalUsedMaxCnt && subsidy.availableRemainingCount) ||
                        (subsidy.availableRemainingCount === 0 && subsidy.availableData.parsonalUsedMaxCnt)
                      "
                    >
                      <dt class="w-3/12 md:w-5/12 sm:w-4/12 md:text-xs">
                        <span class="titleblock">保有枚数</span>
                      </dt>
                      <dd class="w-9/12 md:w-7/12 sm:w-8/12 md:text-xs">
                        {{ subsidy.availableRemainingCount | formatInteger }}/{{
                          subsidy.availableData.parsonalUsedMaxCnt | formatInteger
                        }}枚
                      </dd>
                    </template>
                    <template
                      v-if="parsonalUsedMaxTotalAmt(subsidy) && subsidy.availableRemainingAmount >= 0"
                    >
                      <dt class="w-5/12 md:w-7/12 sm:w-5/12 md:text-xs">
                        <span class="titleblock">利用可能残金額</span>
                      </dt>
                      <dd class="w-7/12 md:w-5/12 sm:w-7/12 md:text-xs">
                        {{ subsidy.availableRemainingAmount | formatInteger }}/{{
                          parsonalUsedMaxTotalAmt(subsidy) | formatInteger
                        }}円
                      </dd>
                    </template>
                  </template>
                  <template v-else>
                    <template v-if="remainingCountLabel(subsidy) && remainingCountLabel(subsidy).length > 0">
                      <dt class="w-2/12 md:w-3/12 md:text-xs">
                        <span class="titleblock">保有枚数</span>
                      </dt>
                      <dd class="w-10/12 md:w-9/12 md:text-xs">
                        <span
                          class="inline-block"
                          style="margin-right: 15px"
                          v-for="(value, idx) in remainingCountLabel(subsidy)"
                          :key="idx"
                          >{{ value }}枚</span
                        >
                      </dd>
                    </template>
                    <template v-if="remainingAmountLabel(subsidy) && remainingAmountLabel(subsidy).length > 0">
                      <dt class="w-3/12 md:w-5/12 md:text-xs">
                        <span class="titleblock">保有金額</span>
                      </dt>
                      <dd class="w-9/12 md:w-7/12 md:text-xs">
                        <span
                          class="inline-block"
                          style="margin-right: 15px"
                          v-for="(value, idx) in remainingAmountLabel(subsidy)"
                          :key="idx"
                          >{{ value }}円</span
                        >
                      </dd>
                    </template>
                  </template>

                  <dl
                    class="flex w-full flex-wrap gap-y-0 md:gap-y-2 unit-price"
                    v-for="(price, index) in subsidy.availableData.priceList"
                    :key="price.id"
                  >
                    <dt class="w-6/12 md:w-6/12 md:text-xs">
                      <span v-if="index === 0" class="titleblock"
                        >補助単価</span
                      >
                    </dt>
                    <dd class="w-6/12 md:w-6/12 md:text-xs flex flex-wrap ">
                      <template v-if="isCorporate(subsidy)">
                        <div class="w-6/12 md:w-full flex">
                          <div v-if="price.priceType !== '一律'" class="w-6/12 md:w-6/12">
                            {{ price.priceType }}
                          </div>
                          <div v-if="price.ageType !== '一律'" class="w-6/12 md:w-6/12">
                            {{ price.ageType }}
                          </div>
                        </div>
                        <span class="w-6/12 md:w-full">
                          {{ price.price | formatInteger }}円
                        </span>
                      </template>
                      <template v-else>
                        {{
                          price.priceType !== '一律' ? `${price.priceType}（${price.ageType}）：` : ''
                        }}
                        {{ price.price | formatInteger }}円
                      </template>
                    </dd>
                    <dt class="w-6/12 md:w-6/12 md:block md:text-xs">
                      <span v-if="index === 0" class="titleblock"
                        >有効期限</span
                      >
                    </dt>
                    <dd class="w-6/12 md:w-6/12 md:text-xs limit">
                      <div v-if="price.limApplicableDateFrom">
                        {{ price.limApplicableDateFrom }}
                      </div>
                      <div v-if="price.limApplicableDateTo"> ~{{ price.limApplicableDateTo }} </div>
                    </dd>
                  </dl>
                </dl>
                <div class="mt-4 md:text-xs">
                  <div v-if="infoTexts(subsidy)" v-html="infoTexts(subsidy)" />

                  <template v-if="!isCorporate(subsidy)">
                    <div v-for="(desc, index) in applicableDegreeCntText(subsidy)"
                      v-html="desc"
                      :key="index">
                    </div>
                    <!-- <div v-if="applicableDegreeCntText(subsidy)" v-html="applicableDegreeCntText(subsidy)" /> -->
                  </template>
                </div>
                <div>
                  {{ subsidy.availableData.dispNoteComment}}
                </div>
                <!--
                  レイアウト仕様変更により一度コメントアウトする
                  UI/UX関連の場合、要確認
                -->
                <!-- <div class="mt-4 md:text-xs">
                  本人同行要否：
                  {{ subsidy.availableData.personAccompanyFlg === CONST_DATA.PERSON_ACCOMPANY_FLG.NEED ? '必要' : '不要' }}
                </div>
                <div class="mt-1 md:text-xs">
                  {{
                    subsidy.availableData.usedLimTerm === '01'
                      ? '上記適用期間内での制限適用となります'
                      : '月の利用制限となります'
                  }}
                </div> -->
              </details>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash'

export default {
  name: 'SubsidyGroupDetail',
  props: {
    subsidy: {
      type: Array,
      default: () => {}
    },
    subsidyShow: {
      type: Boolean,
    },
  },
  computed: {
    
  },
  methods: {
    get,
    /**
     * 企業補助金か判定する
     */
    isCorporate(subsidy) {
      if (
        subsidy.availableData.requestType ==
        this.CONST_DATA.SUBSIDY_REQUEST_TYPE.CORPORATE
      ) {
        return true
      }
      return false
    },
    infoTexts(subsidy) {
      const item = subsidy.availableData
      const itemTexts = {}

      // 利用制限期間
      if (item.usedLimTerm) {
        switch (item.usedLimTerm) {
          case '01': //年
            itemTexts.usedLimTerm = '上記適用期間内での制限適用となります'
            break
          case '02': //月
            itemTexts.usedLimTerm = '月の利用制限となります'
        }
      }
      // 利用上限総額（数）
      // usedLimUnit(利用制限単位)による条件分岐は不要。
      // usedLimUnitが01(個人)の場合は、usedMaxCnt・usedMaxTotalAmtはセットされない
      if (item.usedMaxCnt > 0 && item.usedMaxTotalAmt > 0) {
        itemTexts.usedMaxCnt = `所属団体様内で先着${this.$filters.formatInteger(
          item.usedMaxCnt
        )}枚まで/※本補助クーポンは数量限定となります。なくなり次第終了となりますのでご了承ください。`
      } else if (item.usedMaxCnt > 0 && !item.usedMaxTotalAmt) {
        itemTexts.usedMaxCnt = `所属団体様内で先着${this.$filters.formatInteger(
          item.usedMaxCnt
        )}枚まで`
      } else if (!item.usedMaxCnt && item.usedMaxTotalAmt > 0) {
        itemTexts.usedMaxCnt =
          '※本補助クーポンは数量限定となります。なくなり次第終了となりますのでご了承ください。'
      }

      // 会員最低負担額
      if (item.minChargeAmt) {
        if (item.minChargeAmt > 1) {
          itemTexts.minChargeAmt = `${this.$filters.formatInteger(
            item.minChargeAmt
          )}円以上のご負担が必要となります。`
        } else if (item.minChargeAmt === 1) {
          itemTexts.minChargeAmt = '必ず自己負担が必要になります。'
        }
      }
      // 実費未満投入可否 ※最低金額の設定が無い場合のみ表示
      if (
        item.costUnderChargeableFlg === this.CONST_DATA.COST_UNDER_CHARGEABLE_FLG.DISABLED && !item.minChargeAmt
      ) {
        itemTexts.costUnderChargeableFlg = '利用金額が補助金額に満たない場合は利用不可'
      }
      // 対象最低年齢
      if (item.minTgtAge) {
        itemTexts.minTgtAge = `${this.$filters.formatInteger(item.minTgtAge)}歳以上が対象`
      }
      // 本人同行要否
      if (item.personAccompanyFlg) {
        if (item.personAccompanyFlg === this.CONST_DATA.PERSON_ACCOMPANY_FLG.NEED) {
          itemTexts.personAccompanyFlg = '家族会員のみでの利用不可'
        }
      }

      // 複数使用不可
      if (item.multipleUnusableFlg) {
        switch (item.multipleUnusableFlg) {
          case this.CONST_DATA.MULTIPLE_UNUSABLE_FLG.USABLE:
            itemTexts.multipleUnusableFlg = '併用可'
            break
          case this.CONST_DATA.MULTIPLE_UNUSABLE_FLG.UNUSABLE:
            itemTexts.multipleUnusableFlg = '併用不可'
            break
          default:
            break
        }
      }

      // 利用形態区分
      if (item.usedFormDiv) {
        switch (item.usedFormDiv) {
          case '01':
            itemTexts.usedFormDiv = '対象メニューの申込で自動で利用できます'
            break
          case '02':
            itemTexts.usedFormDiv = '利用申請があった場合のみ利用できます'
        }
      }

      return Object.values(itemTexts).join('/')
    },
    infoGroupTexts(subsidy) {
      let message = [];

      // 利用制限期間
      if (subsidy.availableData.groupInfo.usedLimTerm === "01") {
        message.push("上記適用期間内での制限適用となります");
      } else {
        message.push("月の利用制限となります");
      }

      // 利用上限総額（数）
      if (
        subsidy.availableData.groupInfo.usedMaxCnt > 0 &&
        subsidy.availableData.groupInfo.usedMaxTotalAmt > 0
      ) {
        message.push(`所属団体様内で先着${this.$filters.formatInteger(subsidy.availableData.groupInfo.usedMaxCnt)}枚まで/※本補助クーポンは数量限定となります。なくなり次第終了となりますのでご了承ください。`);
      } else if (
        subsidy.availableData.groupInfo.usedMaxCnt > 0 &&
        !subsidy.availableData.groupInfo.usedMaxTotalAmt
      ) {
        message.push(`所属団体様内で先着${this.$filters.formatInteger(subsidy.availableData.groupInfo.usedMaxCnt)}枚まで`);
      } else if (
        !subsidy.availableData.groupInfo.usedMaxCnt &&
        subsidy.availableData.groupInfo.usedMaxTotalAmt > 0
      ) {
        message.push("※本補助クーポンは数量限定となります。なくなり次第終了となりますのでご了承ください。");
      }

      return message.join('/');
    },
    // 健保補助金の場合のみ実施
    // 続柄制限と枚数・金額上限説明文の取得
    // 
    applicableDegreeCntText(subsidy) {
      const item = subsidy.availableData
      const applicableDegreeCnt = item.applicableDegreeCnt || 0 //続柄数
      const parsonalUsedMaxCnt = item.parsonalUsedMaxCnt || 0 //上限枚数
      const parsonalUsedMaxTotalAmt = item.parsonalUsedMaxTotalAmt || 0 //上限金額
      const availableRemainingAmount = subsidy.availableRemainingAmount || 0 //利用可能残金

      let applicableDegreeCntNote = []

      if (item.requestType == '02') {
        // 利用上限枚数が1枚以上で設定されている場合、最大枚数を表示
        if (parsonalUsedMaxCnt > 0 && parsonalUsedMaxTotalAmt == 0) {
          let disc = applicableDegreeCnt + `親等までを対象者として、1対象者あたり最大` + parsonalUsedMaxCnt + `枚までご利用いただけます。`
          applicableDegreeCntNote.push(disc)        
        }

        // 利用上限金額が1円以上で設定されている場合、最大金額を表示
        if (parsonalUsedMaxTotalAmt > 0 && parsonalUsedMaxCnt == 0) {
          let disc = applicableDegreeCnt + `親等までを対象者として、1対象者あたり最大` + parsonalUsedMaxTotalAmt + `円までご利用いただけます。`
          applicableDegreeCntNote.push(disc)
        }

        // 利用上限金額と利用上限枚数がどちらもが1円・1枚以上で設定されている場合、最大金額を表示
        if (parsonalUsedMaxTotalAmt > 0 && parsonalUsedMaxCnt > 0) {
          let disc = applicableDegreeCnt + `親等までを対象者として、1対象者あたり最大` + parsonalUsedMaxCnt + `枚、` + parsonalUsedMaxTotalAmt + `円までご利用いただけます。`
          applicableDegreeCntNote.push(disc)
        }

        // ＠info:補助金取得処理時点で該当データはフィルタされて存在しないはずだが、SP表示と合わせるため記載とコメントアウト
        // 保有金額設定（残金設定）時の場合、
        // ＜条件＞
        // 利用上限金額が0円の場合（使い切っている場合）または利用上限金額がNULL（上限なし）
        // かつ
        // 保有金額が1円以上存在する場合
        // if ( parsonalUsedMaxTotalAmt == 0 || !parsonalUsedMaxTotalAmt) && availableRemainingAmount > 0) ) {
        //   let disc = `第`+ applicableDegreeCnt + `親等までを対象者として、1対象者あたり最大` + availableRemainingAmount + `円までご利用いただけます`
        //   applicableDegreeCntNote.push(disc)
        // }
      }

      return applicableDegreeCntNote;
    },
    parsonalUsedMaxTotalAmt(subsidy) {
      return get(subsidy, 'availableData.parsonalUsedMaxTotalAmt')
    },
    remainingCountLabel(subsidy) {
      let countLabelArr =
        subsidy?.scrennDisplayItemList?.remainingCountLabel?.value?.split(',') || []
      let countLabel = []
      countLabelArr.forEach((val) => {
        if (!val.includes('上限回数') && !val.includes('|null')) {
          countLabel.push(val.replace('|', '：'))
        }
      })
      return countLabel
    },
    remainingAmountLabel(subsidy) {
      let amountLabelArr =
        subsidy.scrennDisplayItemList?.remainingAmountLabel?.value?.split(',') || []
      let amountLabel = []
      amountLabelArr.forEach((val) => {
        if (!val.includes('上限金額') && !val.includes('|null')) {
          amountLabel.push(val.replace('|', '：'))
        }
      })
      return amountLabel
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-subsidy-detail {
  margin-bottom: 12px;
  
  dl {
    display: flex;
    flex-wrap: wrap;
    row-gap: 0.5rem;
    width: 100%;

    .unit-price {
      dt,
      dd {
        display: flex;
        margin: 0;
        width: 50%;
      }
      :nth-child(1) {
        order: 1;
      }
      :nth-child(2) {
        order: 3;
      }
      :nth-child(3) {
        order: 2;
      }
      :nth-child(4) {
        order: 4;
      }
    }
    
    @include mq() {
      .limit {
        display: inline-block !important;
        div {
          display: block;
        }
      }
    }

    .titleblock {
      @apply bg-gray-200 inline-block py-0.5 px-2;
      @screen sm{
        background-color: #ede3d0;
      }
    }
  }
}
</style>